import request from 'lib/request'

/**
 * Track when user enters email before they sign up.
 *
 * @param {Object} email    Email address
 * @param {Object} location Friendly name of where the lead was captured (e.g: `signup form`)
 * @return {Promise}
 */
export function leadCaptured(email, location) {
  // analytics.user() sometimes isn't defined.
  // e.g: analytics.js is still loading, adblocker etc
  let suggestedId = ''
  if (window.analytics.user && window.analytics.user().id) {
    suggestedId = window.analytics.user().id()
  }

  return request('/api/users/reserve', {
    method: 'POST',
    body: JSON.stringify({
      email,
      suggestedId
    })
  })
    .then(res => {
      if (!res.ok) {
        throw new Error('Unable to reserve user ID')
      }
      return res.json()
    })
    .then(({ id }) => {
      window.analytics.identify(id, { email })
    })
    .catch(() => {
      // Capture the lead even if an ID couldn't be reserved
      window.analytics.identify({ email })
    })
    .then(() => {
      // Add url for tools like Amplitude that don't get info from the context object
      window.analytics.track('Lead Captured', {
        email,
        url: window.location.href,
        location
      })
    })
}
